import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaMobileAlt } from 'react-icons/fa';

import { Modal } from '../Utils/ModalShow';
import {
  abonnerInstallation,
  consommerInvite,
  estInstallee,
  estIos,
  inviteInstallation,
} from '../Utils/installationPwa';

/**
 * « Installer l'application » de l'espace collaborateur (Yros/Kavero#488).
 *
 * Absent quand le portail tourne déjà comme application, ou quand le
 * navigateur ne sait pas l'installer. Sur iPhone, il ouvre les deux gestes à
 * faire dans Safari : aucun site ne peut y déclencher l'installation.
 */
function BoutonInstallerApplication() {
  const { t } = useTranslation();
  const [invite, setInvite] = useState(inviteInstallation);
  const [aideIos, setAideIos] = useState(false);

  useEffect(() => abonnerInstallation(() => setInvite(inviteInstallation())), []);

  if (estInstallee()) return null;
  const ios = estIos();
  if (!invite && !ios) return null;

  const installer = async () => {
    if (!invite) {
      setAideIos(true);
      return;
    }
    const courante = consommerInvite();
    await courante.prompt();
  };

  return (
    <>
      <button
        type="button"
        data-testid="installer-application"
        onClick={installer}
        aria-label={t('installerApplication.bouton')}
        title={t('installerApplication.bouton')}
        className="flex items-center justify-center gap-2 w-11 h-11 sm:w-auto sm:h-auto sm:min-h-[44px] sm:px-4 rounded-full bg-[--color-primary] text-white text-sm font-medium
                   hover:bg-[--bg-hover] transition-colors focus:outline-none focus:ring-2 focus:ring-[--color-primary]"
      >
        <FaMobileAlt aria-hidden="true" />
        <span className="hidden sm:inline">{t('installerApplication.bouton')}</span>
      </button>
      <Modal
        isOpen={aideIos}
        onClose={() => setAideIos(false)}
        title={t('installerApplication.titreIos')}
        size={420}
      >
        <ol data-testid="installer-application-aide-ios" className="list-decimal pl-5 space-y-2 text-sm text-slate-700">
          <li>{t('installerApplication.etapePartager')}</li>
          <li>{t('installerApplication.etapeEcranAccueil')}</li>
          <li>{t('installerApplication.etapeAjouter')}</li>
        </ol>
      </Modal>
    </>
  );
}

export default BoutonInstallerApplication;
